import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader = () => {
    const spinnerIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;
    return <div className='col-12 text-center mt-5 mb-5'><Spin indicator={spinnerIcon} /> <br/>Loading...</div>
}
export default Loader;
